import { render, staticRenderFns } from "./friendHelpModal.vue?vue&type=template&id=2565023b&"
import script from "./friendHelpModal.vue?vue&type=script&lang=js&"
export * from "./friendHelpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports